import { Injectable, SystemJsNgModuleLoader } from '@angular/core';
import { ConstantValues } from '../models/bpg-constants';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
//import { BPGLoggerService } from '../../bpg-common/services/bpg-logger.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { environment_Local } from 'src/environments/environment.local';
import { environment_QA } from 'src/environments/environment.qa'
import { environment_PROD } from 'src/environments/environment.prod'
import 'rxjs/Rx';
import { DataService } from './data.services'
import jwt_decode from 'jwt-decode';
import { MatTabBodyPortal } from '@angular/material';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Injectable({
  providedIn: 'root'
})
export class BpgCommonService {

  membershipUrl: String = ConstantValues.userManagementApiUrl.userManagementUrl;
  commonUrl: String = ConstantValues.userManagementApiUrl.userManagementUrl;
  financeUrl: String = ConstantValues.financeManagementApiUrl.financeManagementUrl;
  getAWSUrl: string = ConstantValues.userManagementApiUrl.getAWSurl;
  registerSiteUrl: string = ConstantValues.userManagementApiUrl.registerVirtualSiteUrl;

  codeResponse: any = '';
  id_token: any;
  access_token: any;
  refresh_token: any;
  tokenURL: any = environment.tokenUrl
  public isSiteOrBpgCreated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public headerRefresh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public loginError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private setloggedInSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  setloggedInObservable = () => this.setloggedInSubject$.asObservable();
  private  isTokenReceived = new BehaviorSubject(sessionStorage.getItem('id_token')==null||sessionStorage.getItem('XAapiKey')==null?null:true); 
  isTokenPresent = this.isTokenReceived.asObservable();


  constructor(
    private http: HttpClient,
    private environment1: EnvironmentConfiguration,
    // private logger: BPGLoggerService,
    private spinner: Ng4LoadingSpinnerService,
    private router: Router, private dataService: DataService
  ) { }

  getSessionToken() {

    {
      let getAWSCredURL;
      if (this.environment1.envName == 'default' || this.environment1.envName == 'local' || this.environment1.envName == 'staging') {
        getAWSCredURL = environment_Local.getAWSCredURL
      } else if (this.environment1.envName == 'qa') {
        getAWSCredURL = environment_QA.getAWSCredURL
      }
      else if (this.environment1.envName == 'prod') {
        getAWSCredURL = environment_PROD.getAWSCredURL
      }
      const options = {
        headers: new HttpHeaders({
          'Authorization': sessionStorage.getItem('id_token'),
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }),

      };
      let response2 = this.http.get(getAWSCredURL, options).subscribe(async (res2: any) => {

        if (res2 != null && res2 != undefined) {
          sessionStorage.setItem('AccessKeyId', (res2['access-key']));
          sessionStorage.setItem('SecretKeyId', (res2['secret-key']));
          sessionStorage.setItem('SessionToken', (res2['session-token']));

        }
      })
    }

  }
  async userLogin() {
    this.spinner.show();
    let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',

        }),
        'responseType': 'text'

      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        })
      };
    }
    this.codeResponse = sessionStorage.getItem('codeResponse');
    let redirectUri;
    let clientId;
    let getXApiKeyUrl;
    if (this.environment1.envName == 'default' || this.environment1.envName == 'local' || this.environment1.envName == 'staging') {
      redirectUri = environment_Local.redirectUri
      clientId = environment_Local.clientId
      getXApiKeyUrl = environment_Local.getXApiKeyUrl

    } else if (this.environment1.envName == 'qa') {
      redirectUri = environment_QA.redirectUri
      clientId = environment_QA.clientId
      getXApiKeyUrl = environment_QA.getXApiKeyUrl

    }
    else if (this.environment1.envName == 'prod') {
      redirectUri = environment_PROD.redirectUri
      clientId = environment_PROD.clientId
      getXApiKeyUrl = environment_PROD.getXApiKeyUrl
    }
    var details = {
      'grant_type': 'authorization_code',
      'client_id': clientId,
      'code': this.codeResponse,
      'redirect_uri': redirectUri,
      'code_verifier': environment.codeVerifier
    };
    var formBody = [];
    for (var property in details) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(details[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    let body = formBody.join("&");
    let response = await this.http.post(this.tokenURL, body, httpOptions).subscribe(async (res: any) => {
      if (res != null) {
        // this.roleTypeSubject$.next(true);
        this.id_token = res.id_token;
        this.access_token = res.access_token;
        this.refresh_token = res.refresh_token;
        sessionStorage.setItem('id_token', this.id_token);
        sessionStorage.setItem('access_token', this.access_token);
        sessionStorage.setItem('refresh_token', this.refresh_token);
        if (this.id_token != null || this.access_token != null) {
          var decodedIDToken = jwt_decode(this.id_token);
          var decodedACCESSToken = jwt_decode(this.access_token);
          sessionStorage.setItem('BPG_IDTOKEN', JSON.stringify(decodedIDToken));
          sessionStorage.setItem('BPG_ACCESSTOKEN', JSON.stringify(decodedACCESSToken));
          var BPG_IDTOKEN = sessionStorage.getItem("BPG_IDTOKEN")
          var BPG_ACCESSTOKEN = sessionStorage.getItem("BPG_ACCESSTOKEN")
          var userEmail = JSON.parse(BPG_ACCESSTOKEN)["upn"]
          var userFirstName = JSON.parse(BPG_ACCESSTOKEN)["given_name"]
          var userLastName = JSON.parse(BPG_ACCESSTOKEN)["family_name"]
          var workdayId = JSON.parse(BPG_IDTOKEN)["WorkdayId"]
          sessionStorage.setItem("userEmail", userEmail);
          sessionStorage.setItem("userFirstName", userFirstName);
          sessionStorage.setItem("userLastName", userLastName);
          sessionStorage.setItem("workdayId", workdayId);
          sessionStorage.setItem('loginSuccess', 'true');
          sessionStorage.setItem("firstLogin", 'true');

          if (this.environment1.envName == 'default' || this.environment1.envName == 'local' || this.environment1.envName == 'staging') {
            localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl + '7000');
            localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl + '7001');
            localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl + '7002');
          } else if (this.environment1.envName == 'qa' || this.environment1.envName == 'prod') {
            localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
            localStorage.setItem('eventManagementUrl', this.environment1.eventapiBaseUrl);
            localStorage.setItem('financialManagementUrl', this.environment1.financeapiBaseUrl);
          }
          else {
            localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
            localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl);
            localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl);
          }
          const options = {
            headers: new HttpHeaders({
              'Authorization': sessionStorage.getItem('id_token'),
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }),
            responseType: 'text' as 'json'
          };
          let response1 = this.http.get(getXApiKeyUrl, options).subscribe(async (res: any) => {
            const XAapiKey = res;
            sessionStorage.setItem('XAapiKey', XAapiKey);
            this.isTokenReceived.next(true);
 
          })

        }
        

      }

    })

    return response;
  }



  async refreshToken() {
    let clientId;
    if (this.environment1.envName == 'default' || this.environment1.envName == 'local' || this.environment1.envName == 'staging') {
      clientId = environment_Local.clientId
    } else if (this.environment1.envName == 'qa') {
      clientId = environment_QA.clientId
    }
    else if (this.environment1.envName == 'prod') {
      clientId = environment_PROD.clientId
    }
    let data = {
      'grant_type': "refresh_token",
      'client_id': clientId,
      'refresh_token': sessionStorage.getItem('refresh_token')
    };

    let refreshBody = [];
    for (let property in data) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(data[property]);
      refreshBody.push(encodedKey + "=" + encodedValue);
    }

    let body = refreshBody.join("&");
    let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        })
      };
    }


    let response = await this.http.post(this.tokenURL, body, httpOptions).subscribe(async (res: any) => {
      if (res != null) {
        if (res != null) {
          this.id_token = res.id_token
          this.access_token = res.access_token
          this.refresh_token = res.refresh_token
          sessionStorage.setItem('id_token', this.id_token)
          sessionStorage.setItem('refresh_token', this.refresh_token)
        }
      }
    })
  }

  setloggedInHeader() {
    this.setloggedInSubject$.next(true);
  }
  //  async getTokens(tokenBody) {
  //   let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  //   let tokenURL = 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token'
  //   let httpOptions;
  //   if (isIEOrEdge) {
  //     httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  //         'Cache-Control': 'no-cache',
  //         'Pragma': 'no-cache',
  //       })
  //     };
  //   } else {
  //     httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  //       })
  //     };
  //   }
  //   return await this.http.post(tokenURL, tokenBody, httpOptions)
  //   .map((response: any) => response)
  //   .catch(this.handleError).toPromise();
  // }



  /** For service call to get bpg list depending on site(location)
   * @class BpgCommonService
   * @method getBPGsList
   * @param landingData
   * @returns Observable
   */

  getBPGsList(landingData: any): Observable<any> {
    let getBPGListUrl = this.membershipUrl + ConstantValues.membershipApiUrl.sitebpgList;
    return this.http.post(getBPGListUrl, landingData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }))
      .pipe(catchError((error: any) => {
        //this.logger.logException(ConstantValues.modules.bpgCommonServiceModule, '', 'Getting bpg lists details failed in bpg-site-homepage-component.ts', '', error);
        throw of(error);
      }))
  }
  /** For service call to get bpg list depending on userId
    * @class BpgCommonService
    * @method getMyBPGsList
    * @param myBpgsData
    * @returns Observable
    */

  getMyBPGsList(myBpgsData: any): Observable<any> {
    let getBPGListUrl = this.membershipUrl + ConstantValues.membershipApiUrl.bpgList;
    return this.http.post(getBPGListUrl, myBpgsData, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));
  }
  /** For service call to get site list depending on userId
  * @class BpgCommonService
  * @method getSiteist
  * @param mysiteData
  * @returns Observable
  */

  getMySiteList(mysiteData: any): Observable<any> {
    let getSiteListUrl = this.membershipUrl + ConstantValues.membershipApiUrl.siteList;
    return this.http.post(getSiteListUrl, mysiteData, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));
  }


  /** For service call to get site list of the user
   * @class BpgCommonService
   * @method getSiteList
   * @param myBpgsData
   * @returns Observable
   */
  getSiteList(siteData: any): Observable<any> {
    let getBPGListUrl = this.membershipUrl + ConstantValues.userManagementApiUrl.siteList;
    return this.http.post(getBPGListUrl, siteData, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));
  }

  /** For service call to get site list of the user
   * @class BpgCommonService
   * @method getRegisteredSiteList
   * @param myBpgsData
   * @returns Observable
   */
  getRegisteredSiteList(userId): Observable<any> {
    let getBPGListUrl = this.membershipUrl + this.registerSiteUrl;
    return this.http.get(getBPGListUrl + userId, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));
  }


  /** For service call to get chapter members details depending on siteIds and bpgId
 * @class BpgCommonService
 * @method getChapterEmailList
  * @param myData
 * @returns Observable
 */
  getChapterEmailList(myData: any): Observable<any> {
    let getChapterEmailUrl = this.membershipUrl + ConstantValues.membershipApiUrl.chapterEmailList;
    return this.http.post(getChapterEmailUrl, myData, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));

  }
  /** For service call to login to bpg application locally
     * @class BpgCommonService
     * @method login
     * @param loginData
     * @returns Observable
     */

  login(loginData: any): Observable<any> {
    let loginUrl = this.commonUrl + ConstantValues.commonApiUrl.login;
    return this.http.post(loginUrl, loginData)
      .pipe(map((data: any) => {
        return data;
      }));

  }

  loginMonitor(loginData: any): Observable<any> {
    let loginUrl = this.commonUrl + ConstantValues.commonApiUrl.loginMonitor;
    return this.http.post(loginUrl, loginData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));
  }

  checkSiteAffected(value): Observable<any> {
    let checkSiteAffectedUrl = this.commonUrl + ConstantValues.commonApiUrl.checkSiteAffected + value;
    return this.http.get(checkSiteAffectedUrl, this.tokenizedHeader())    
    .pipe(map((data: any) => {
      return data;
    }));
}
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getUserRoleDetails
     * @param userData
     * @returns Observable
     */

  getUserRoleDetails(userData: any): Observable<any> {
    let userRoleDetailsUrl = this.commonUrl + ConstantValues.commonApiUrl.userRole;
    return this.http.post(userRoleDetailsUrl, userData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));

  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getChapterDetails
     * @param chapterDetailsData
     * @returns Observable
     */
  getChapterDetails(chapterDetailsData: any): Observable<any> {
    // console.log("hhhh=="+chapterDetailsData);

    let chapterDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.chapterDetails;
    return this.http.post(chapterDetailsUrl, chapterDetailsData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));

  }

  /** For service call to get chapter folder list
   * @class BpgCommonService
   * @method getChapterFolderDetails
   * @param getChapterFolderDetails
   * @returns Observable
   */
  getChapterFolderDetails(getChapterFolderDetails: any): Observable<any> {
    // console.log("hhhh=="+chapterDetailsData);

    let chapterDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.chapterFolderDetails;
    console.log(chapterDetailsUrl)
    return this.http.post(chapterDetailsUrl, getChapterFolderDetails, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));



  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method withdrawMemberShip
     * @param userId
     * @returns Observable
     */
  withdrawMemberShip(userId: any): Observable<any> {
    //console.log("id===-====-=0-0=="+userId);
    let withdrawMembershipUrl = this.commonUrl + ConstantValues.userManagementApiUrl.withdrawMembership;
    return this.http.delete(withdrawMembershipUrl + userId, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));
  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getChapterLeadershipDetails
     * @param chapterId
     * @returns Observable
     */
  getChapterLeadershipDetails(chapterId: any): Observable<any> {
    let chapterLeadershipDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.chapterLeadershipDetails;
    return this.http.post(chapterLeadershipDetailsUrl, chapterId, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));

  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getUserSiteDeatils
     * @param siteId
     * @returns Observable
     */
  getUserSiteDeatils(siteId: any): Observable<any> {
    //console.log("site bnsdjhshjhafgjghs"+siteId);
    let userSiteDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.userSiteDetails;
    return this.http.post(userSiteDetailsUrl, { "siteId": siteId }, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }))
      .pipe(catchError((error: any) => {
        // this.logger.logException(ConstantValues.modules.bpgCommonServiceModule, '', 'Getting user site details failed in bpg-site-homepage-component.ts', '', error);
        throw of(error);
      }))
  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getUserDetails
     * @param userId
     * @returns Observable
     */
  getUserDetails(userId: any): Observable<any> {
    let userDetailUrl = this.commonUrl + ConstantValues.commonApiUrl.userDetails;
    return this.http.post(userDetailUrl, { "userId": userId }, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));

  }

  /** For service call to check for ADAL login
     * @class BpgCommonService
     * @method tokenizedHeader
     * @returns header options
     */
  tokenizedHeader(): any {
    //console.log("Header Authorized : " + this.adalService.userInfo.token);

    //if(ConstantValues.env.loginADAL == true) {

    if (localStorage.getItem('logOutFlag') == "true") {
      localStorage.clear();
      sessionStorage.clear();
      //this.router.navigate['/log-out'];
      localStorage.setItem("logOutFlag", "true");

    }
    else {
      if (sessionStorage.getItem('id_token') == null) {
        this.userLogin()
      }
      if (sessionStorage.getItem('id_token') != null) {

        if (sessionStorage.getItem("XAapiKey") != null && sessionStorage.getItem("XAapiKey") != undefined) {
          var headers = new HttpHeaders({
            Authorization: sessionStorage.getItem("id_token"),
            "X-Api-Key": sessionStorage.getItem("XAapiKey"),
          });
        } else {
          var headers = new HttpHeaders({
            Authorization: sessionStorage.getItem("id_token"),
          });
        }
        //}
        let options = { headers: headers };
        //console.log("Header Authorized option : " + this.adalService.userInfo.token);
        return options;
      }

    }
  }

  /** For service call to get user data by email id
   * @class BpgCommonService
   * @method userDetailsByEmailId
   * @param emailData
   * @returns Observable
   */

  userDetailsByEmailId(emailData: any): Observable<any> {

    if (this.commonUrl == null) {
      this.commonUrl = localStorage.getItem('userManagementUrl');
    }
    let loginUrl = this.commonUrl + ConstantValues.commonApiUrl.userDetailsByEmailId;

    return this.http.post(loginUrl, emailData, this.tokenizedHeader())
      .pipe(map((data: any) => {

        return data;
      }));
  }

  /** For service call to get AWS Base URL
  * @class BpgCommonService
  * @method getAwsUrl
  * @param awsData
  * @returns Observable
  */

  getAwsUrl(awsData: any): Observable<any> {
    let awsUrl = this.commonUrl + this.getAWSUrl;
    return this.http.post(awsUrl, awsData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));
  }

}
